import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // Header
    findPro: "Trouver un Pro",
    categories: "Catégories",
    login: "Connexion",
    register: "S'inscrire",
    dashboard: "Tableau de bord",
    logout: "Déconnexion",
    
    // Landing Page
    heroTitle: "Trouvez le professionnel idéal pour vos projets",
    heroSubtitle: "Plus de 50 métiers disponibles. Des artisans qualifiés en Outaouais, prêts à intervenir.",
    searchPlaceholder: "Quel service recherchez-vous ?",
    search: "Rechercher",
    popular: "Populaires",
    
    // Trust indicators
    verified: "Vérifiés",
    verifiedDesc: "Profils validés",
    avgRating: "Note moyenne",
    guarantee: "Garantie",
    guaranteeDesc: "Satisfaction",
    fast: "Rapide",
    fastDesc: "Réponse en 24h",
    
    // Categories
    ourServices: "Nos services",
    exploreCategories: "Explorez nos catégories",
    viewAll: "Voir tout",
    tradesAvailable: "métiers disponibles",
    
    // How it works
    simpleAndFast: "Simple & Rapide",
    howItWorks: "Comment ça marche ?",
    step1Title: "Recherchez",
    step1Desc: "Trouvez le professionnel idéal parmi nos 50+ catégories de métiers.",
    step2Title: "Réservez",
    step2Desc: "Choisissez un créneau disponible et décrivez votre besoin.",
    step3Title: "Profitez",
    step3Desc: "Le professionnel intervient et vous évaluez sa prestation.",
    
    // CTA
    youArePro: "Vous êtes professionnel ?",
    joinNetwork: "Rejoignez notre réseau et développez votre clientèle. Inscription gratuite et sans engagement.",
    createProProfile: "Créer mon profil professionnel",
    
    // Auth
    welcomeBack: "Bon retour !",
    loginToAccess: "Connectez-vous pour accéder à votre espace",
    email: "Email",
    password: "Mot de passe",
    forgotPassword: "Oublié ?",
    loginBtn: "Se connecter",
    noAccount: "Pas encore de compte ?",
    
    createAccount: "Créer un compte",
    joinHandyverse: "Rejoignez HandyVerse en quelques clics",
    iAm: "Je suis",
    individual: "Particulier",
    professional: "Professionnel",
    firstName: "Prénom",
    lastName: "Nom",
    phone: "Téléphone (optionnel)",
    confirmPassword: "Confirmer le mot de passe",
    createMyAccount: "Créer mon compte",
    alreadyAccount: "Déjà un compte ?",
    
    // Language
    language: "Langue",
    french: "Français",
    english: "English",
    
    // Search
    findProfessional: "Trouver un professionnel",
    city: "Ville",
    filters: "Filtres",
    category: "Catégorie",
    allCategories: "Toutes les catégories",
    trade: "Métier",
    allTrades: "Tous les métiers",
    clear: "Effacer",
    professionalsFound: "professionnel(s) trouvé(s)",
    noResults: "Aucun résultat",
    tryModifySearch: "Essayez de modifier vos critères de recherche",
    clearFilters: "Effacer les filtres",
    new: "Nouveau",
    
    // Professional Detail
    back: "Retour",
    perHour: "par heure",
    book: "Réserver",
    unavailable: "Indisponible",
    loginToBook: "Connectez-vous pour réserver",
    about: "À propos",
    clientReviews: "Avis clients",
    noReviews: "Pas encore d'avis",
    beFirstReview: "Soyez le premier à donner votre avis !",
    contact: "Contact",
    information: "Informations",
    experience: "Expérience",
    years: "ans",
    status: "Statut",
    available: "Disponible",
    
    // Booking
    bookProfessional: "Réserver",
    desiredDate: "Date souhaitée",
    selectDate: "Sélectionner une date",
    interventionAddress: "Adresse d'intervention",
    describeNeed: "Description de votre besoin",
    describeProject: "Décrivez votre projet ou problème...",
    confirmBooking: "Confirmer la réservation",
    
    // Dashboard Client
    hello: "Bonjour",
    manageBookings: "Gérez vos réservations et trouvez des professionnels",
    findAPro: "Trouver un pro",
    currentBookings: "Réservations en cours",
    completedBookings: "Réservations terminées",
    contactedPros: "Professionnels contactés",
    noCurrentBookings: "Aucune réservation en cours",
    findProfessionalBtn: "Trouver un professionnel",
    viewProfile: "Voir le profil",
    cancel: "Annuler",
    history: "Historique",
    
    // Dashboard Pro
    dashboardTitle: "Tableau de bord",
    manageProfileBookings: "Gérez votre profil et vos réservations",
    availability: "Disponibilité",
    pending: "En attente",
    accepted: "Acceptées",
    completed: "Terminées",
    rating: "Note moyenne",
    requests: "Demandes",
    bookings: "Réservations",
    myProfile: "Mon profil",
    pendingRequests: "Demandes en attente",
    noPendingRequests: "Aucune demande en attente",
    acceptedBookings: "Réservations acceptées",
    noActiveBookings: "Aucune réservation active",
    accept: "Accepter",
    reject: "Refuser",
    markCompleted: "Marquer comme terminé",
    editProfile: "Modifier mon profil",
    
    // Profile creation
    createProProfileTitle: "Créer votre profil professionnel",
    description: "Description",
    describeActivity: "Décrivez votre activité, vos compétences...",
    hourlyRate: "Tarif horaire (CAD)",
    yearsExperience: "Années d'expérience",
    address: "Adresse (optionnel)",
    createMyProfile: "Créer mon profil",
    save: "Sauvegarder",
    
    // Categories page
    explore: "Explorer",
    allCategoriesTitle: "Toutes les catégories",
    categoriesDescription: "Découvrez plus de 50 métiers dans 8 catégories différentes. Trouvez le professionnel parfait pour vos besoins.",
    seeAllTrades: "Voir les métiers",
    others: "autres",
    
    // Status
    statusPending: "En attente",
    statusAccepted: "Acceptée",
    statusRejected: "Refusée",
    statusCompleted: "Terminée",
    statusCancelled: "Annulée",
    
    // Footer
    footerDesc: "La plateforme de mise en relation entre particuliers et professionnels qualifiés au Québec.",
    services: "Services",
    popularCategories: "Catégories populaires",
    construction: "Bâtiment",
    repair: "Réparation",
    servicesCategory: "Services",
    nature: "Nature",
    
    // Regions
    region: "Région",
    gatineau: "Gatineau",
    outaouais: "Outaouais",
    quebec: "Québec",
    canada: "Canada",
  },
  en: {
    // Header
    findPro: "Find a Pro",
    categories: "Categories",
    login: "Login",
    register: "Sign Up",
    dashboard: "Dashboard",
    logout: "Logout",
    
    // Landing Page
    heroTitle: "Find the perfect professional for your projects",
    heroSubtitle: "Over 50 trades available. Qualified professionals in Outaouais, ready to help.",
    searchPlaceholder: "What service are you looking for?",
    search: "Search",
    popular: "Popular",
    
    // Trust indicators
    verified: "Verified",
    verifiedDesc: "Validated profiles",
    avgRating: "Average rating",
    guarantee: "Guarantee",
    guaranteeDesc: "Satisfaction",
    fast: "Fast",
    fastDesc: "24h response",
    
    // Categories
    ourServices: "Our services",
    exploreCategories: "Explore our categories",
    viewAll: "View all",
    tradesAvailable: "trades available",
    
    // How it works
    simpleAndFast: "Simple & Fast",
    howItWorks: "How does it work?",
    step1Title: "Search",
    step1Desc: "Find the perfect professional among our 50+ trade categories.",
    step2Title: "Book",
    step2Desc: "Choose an available time slot and describe your needs.",
    step3Title: "Enjoy",
    step3Desc: "The professional intervenes and you rate their service.",
    
    // CTA
    youArePro: "Are you a professional?",
    joinNetwork: "Join our network and grow your clientele. Free registration with no commitment.",
    createProProfile: "Create my professional profile",
    
    // Auth
    welcomeBack: "Welcome back!",
    loginToAccess: "Log in to access your space",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot?",
    loginBtn: "Log in",
    noAccount: "Don't have an account?",
    
    createAccount: "Create an account",
    joinHandyverse: "Join HandyVerse in a few clicks",
    iAm: "I am a",
    individual: "Client",
    professional: "Professional",
    firstName: "First name",
    lastName: "Last name",
    phone: "Phone (optional)",
    confirmPassword: "Confirm password",
    createMyAccount: "Create my account",
    alreadyAccount: "Already have an account?",
    
    // Language
    language: "Language",
    french: "Français",
    english: "English",
    
    // Search
    findProfessional: "Find a professional",
    city: "City",
    filters: "Filters",
    category: "Category",
    allCategories: "All categories",
    trade: "Trade",
    allTrades: "All trades",
    clear: "Clear",
    professionalsFound: "professional(s) found",
    noResults: "No results",
    tryModifySearch: "Try modifying your search criteria",
    clearFilters: "Clear filters",
    new: "New",
    
    // Professional Detail
    back: "Back",
    perHour: "per hour",
    book: "Book",
    unavailable: "Unavailable",
    loginToBook: "Log in to book",
    about: "About",
    clientReviews: "Client reviews",
    noReviews: "No reviews yet",
    beFirstReview: "Be the first to leave a review!",
    contact: "Contact",
    information: "Information",
    experience: "Experience",
    years: "years",
    status: "Status",
    available: "Available",
    
    // Booking
    bookProfessional: "Book",
    desiredDate: "Desired date",
    selectDate: "Select a date",
    interventionAddress: "Service address",
    describeNeed: "Description of your need",
    describeProject: "Describe your project or issue...",
    confirmBooking: "Confirm booking",
    
    // Dashboard Client
    hello: "Hello",
    manageBookings: "Manage your bookings and find professionals",
    findAPro: "Find a pro",
    currentBookings: "Current bookings",
    completedBookings: "Completed bookings",
    contactedPros: "Professionals contacted",
    noCurrentBookings: "No current bookings",
    findProfessionalBtn: "Find a professional",
    viewProfile: "View profile",
    cancel: "Cancel",
    history: "History",
    
    // Dashboard Pro
    dashboardTitle: "Dashboard",
    manageProfileBookings: "Manage your profile and bookings",
    availability: "Availability",
    pending: "Pending",
    accepted: "Accepted",
    completed: "Completed",
    rating: "Average rating",
    requests: "Requests",
    bookings: "Bookings",
    myProfile: "My profile",
    pendingRequests: "Pending requests",
    noPendingRequests: "No pending requests",
    acceptedBookings: "Accepted bookings",
    noActiveBookings: "No active bookings",
    accept: "Accept",
    reject: "Reject",
    markCompleted: "Mark as completed",
    editProfile: "Edit my profile",
    
    // Profile creation
    createProProfileTitle: "Create your professional profile",
    description: "Description",
    describeActivity: "Describe your activity, your skills...",
    hourlyRate: "Hourly rate (CAD)",
    yearsExperience: "Years of experience",
    address: "Address (optional)",
    createMyProfile: "Create my profile",
    save: "Save",
    
    // Categories page
    explore: "Explore",
    allCategoriesTitle: "All categories",
    categoriesDescription: "Discover over 50 trades in 8 different categories. Find the perfect professional for your needs.",
    seeAllTrades: "See all trades",
    others: "others",
    
    // Status
    statusPending: "Pending",
    statusAccepted: "Accepted",
    statusRejected: "Rejected",
    statusCompleted: "Completed",
    statusCancelled: "Cancelled",
    
    // Footer
    footerDesc: "The platform connecting individuals with qualified professionals in Quebec.",
    services: "Services",
    popularCategories: "Popular categories",
    construction: "Construction",
    repair: "Repair",
    servicesCategory: "Services",
    nature: "Nature",
    
    // Regions
    region: "Region",
    gatineau: "Gatineau",
    outaouais: "Outaouais",
    quebec: "Quebec",
    canada: "Canada",
  }
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('handyverse_language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('handyverse_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
